var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#envelope_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.918 3.182h14.164a.9.9 0 0 1 .648.28c.167.172.27.41.27.672V14.23a.97.97 0 0 1-.159.534.37.37 0 0 1-.172.196.9.9 0 0 1-.587.222H.918a.9.9 0 0 1-.649-.28A.97.97 0 0 1 0 14.23V4.134c0-.262.103-.5.27-.673a.9.9 0 0 1 .648-.28M.704 13.83l4.964-5.162L.704 4.47zm5.51-4.7-5.117 5.322H14.86L9.97 9.13l-1.613 1.425a.34.34 0 0 1-.45.006zm4.29-.472 4.792 5.213V4.424zm-9.35-4.746 6.97 5.893 6.67-5.893z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "envelope_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.182h16v12H0z"
  })))));
};
export default SvgEnvelope;